import * as React from "react"

import clsxm from "@/lib/clsxm"

import type { UnstyledLinkProps } from "@/components/common/Links/UnstyledLink"
import UnstyledLink from "@/components/common/Links/UnstyledLink"

export const PrimaryLink = React.forwardRef<
  HTMLAnchorElement,
  UnstyledLinkProps
>(({ className, children, ...rest }, ref) => {
  return (
    <UnstyledLink
      ref={ref}
      {...rest}
      className={clsxm(
        `cursor-pointer`,
        `inline-flex items-center`,
        `font-medium text-primary-600 hover:text-primary-500`,
        `focus:outline-none focus-visible:rounded focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-offset-2`,
        className
      )}
    >
      {children}
    </UnstyledLink>
  )
})
